"use strict";

angular.module("licensure.services").factory("Services", [
    "$http",
    "$q",
    function ($http, $q) {
        var get = function (args) {
            var d = $q.defer();

            $http
                .get(apiLocation + "/api/services", {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        };

        var getByID = function (id, getLess) {
            var d = $q.defer();

            $http
                .get(apiLocation + "/api/services/" + id, {
                    params: {
                        getLess: getLess
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        };

        var getExpiring = function (serviceClassification, rangeLength, length, inactiveVehicle, inactiveService, activeVehicle, activeService, hideEmptyExpireDate) {
            var d = $q.defer();
            if (isUndefined(serviceClassification) || serviceClassification == null) {
                serviceClassification = "none"
            }

            $http
                .get(apiLocation + "/api/services/getexpiring", {
                    params: {
                        serviceClassification: serviceClassification,
                        rangeLength: rangeLength,
                        length: length,
                        inactiveVehicle: inactiveVehicle,
                        inactiveService: inactiveService,
                        activeVehicle: activeVehicle,
                        activeService: activeService,
                        hideEmptyExpireDate: hideEmptyExpireDate
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        };

        var getLess = function (args) {
            var d = $q.defer();

            $http
                .get(apiLocation + "/api/services/getless", {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        };

        return {
            get: get,
            getByID: getByID,
            getExpiring: getExpiring,
            getLess: getLess,

            getActive: function (args) {
                if (args == null) {
                    args = {};
                }
                args.activeOnly = true;
                return get(args);
            },

            getLessActive: function (args) {
                if (args == null) {
                    args = {};
                }
                args.activeOnly = true;
                return getLess(args);
            },

            getWithHierarchy: function (args) {
                var d = $q.defer();

                if (args == null) {
                    args = {};
                }
                args.activeOnly = false;
                args.hierarchy = true;
                args.allUsers = true;

                if (args.service_classification_filter_ids !== undefined && args.service_classification_filter_ids !== null) {
                    args.serviceClassificationFilterIDs = args.service_classification_filter_ids;
                }

                get(args).then(function (services) {
                    if (services != null) {
                        var allServices = [];
                        services.forEach(function (service) {
                            allServices.push(service);
                            if (service.children != null) {
                                service.children.forEach(function (child) {
                                    allServices.push(child);
                                });
                            }
                        });
                        d.resolve(allServices);
                    } else {
                        d.resolve(services);
                    }
                });

                return d.promise;
            },

            getPotentialChildren: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/services/getchildchoices", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(response.data);
                    });

                return d.promise;
            },

            search: function (args, timeout) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/services/search", {
                        params: args,
                        timeout: timeout != null ? timeout.promise : null
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(response.data);
                    });

                return d.promise;
            },

            // for the user lookup
            getByUserID: function (user_id, detail, enterprise_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/Services/getbyuserid", {
                        params: {
                            user_id: user_id,
                            detail: detail,
                            enterprise_id: enterprise_id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getCounties: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/services/getcounties", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getServiceAffiliationCounties: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/core/service/serviceaffiliationcounties", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getSponsors: function () {
                var args = {
                    activeOnly: true,
                    sponsor: true
                };
                return get(args);
            },

            getTopLevelRegionList: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/services/gettoplevelregionlist", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(response.data);
                    });

                return d.promise;
            },

            PublicLookupService: function (args) {
                var d = $q.defer();

                var newArgs = {
                    enterprise_id: args.enterprise_id,
                    primaryCertificationNumber: args.primary_license_number,
                    serviceName: args.service_name,
                    primaryCertificationLevel: args.primary_license_level,
                    certLevel: args.certification_level_id,
                    trainingLevel: args.training_levels,
                    permitLevel: args.service_permit_level,
                    classificationLevel: args.classification,
                    city: args.city,
                    county: args.county,
                    records_offset: args.records_offset,
                    records_total: args.records_total,
                    sort_fields: args.sort_fields,
                    sort_direction: args.sort_direction,
                    serviceID: args.serviceID
                };

                $http
                    .post(apiLocation + "/api/services/PublicLookupService", newArgs)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getServiceLookupCount: function (args) {
                var d = $q.defer();

                var newArgs = {
                    enterprise_id: args.enterprise_id,
                    primaryCertificationNumber: args.primary_license_number,
                    serviceName: args.service_name,
                    primaryCertificationLevel: args.primary_license_level,
                    trainingLevel: args.training_levels,
                    permitLevel: args.service_permit_level,
                    classificationLevel: args.classification,
                    city: args.city,
                    county: args.county,
                    certificationLevel: args.certification_level_id
                };

                $http
                    .post(
                        apiLocation + "/api/services/getservicelookupcount",
                        newArgs
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getServiceAlerts: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/services/getservicealerts", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getServiceCertifications: function (service_id, detail, enterprise_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/services/getservicecertifications", {
                        params: {
                            service_id: service_id,
                            detail: detail,
                            enterprise_id: enterprise_id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },

            getServiceVehicles: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/services/serviceVehicles", {
                        params: {
                            search: args.search
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getServicesFromVehicleId: function (vehicleId) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/services/servicesFromVehicleId/" + vehicleId, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
        };
    }
]);
